import React from 'react'
import Layout from '../components/layout'
import Faq from '../components/Faq'

export default function FaqPage() {
  return (
    <Layout type={'faq'}>
      <Faq/>
    </Layout>
  )
}
